<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-balance-scale"></i> Feasibility Sustainability</h4>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="feasibility">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Strength of the applicant in hosting CoE </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Strength of the applicant in hosting CoE"
                formControlName="applicantStrength"
                maxlength="20000"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Reasons for the applicant in hosting CoE </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Reasons for the applicant in hosting CoE"
                formControlName="reasonOfApplicant"
                maxlength="20000"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Proposed Focus Sector</mat-label>
              <mat-select
                formControlName="focusSector"
                [ngClass]="{
                  'is-invalid':
                    setting.focusSector.touched && setting.focusSector.errors
                }"
                disabled="{{ showForm }}"
              >
                <mat-option
                  *ngFor="let list of districtdataList"
                  [value]="list"
                  (keydown.enter)="preventEnterKey($event)"
                >
                  {{ list }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Notable achievements of incubatee and incubator so far
              </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Notable achievements of incubatee and incubator"
                formControlName="notableAchievements"
                maxlength="20000"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Sources for identifying and supporting new beneficiaries
              </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Sources of New beneficiaries"
                formControlName="newBeneficiaries"
                maxlength="20000"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Financial model for operational sustainability
              </mat-label>
              <input
                matInput
                readonly="{{ showForm }}"
                placeholder="Enter Financial model"
                formControlName="financialModel"
                maxlength="20000"
                (keydown.enter)="preventEnterKey($event)"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Continue
        </button>
      </div>
    </form>
  </div>
</section>
